import { render, staticRenderFns } from "./pageDeGardeTemplate.vue?vue&type=template&id=5f520723&scoped=true&"
import script from "./pageDeGardeTemplate.vue?vue&type=script&lang=js&"
export * from "./pageDeGardeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./pageDeGardeTemplate.vue?vue&type=style&index=0&id=5f520723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f520723",
  null
  
)

export default component.exports